import React from 'react';
import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {
	return (
		<Helmet>
			<title>{title}</title>
			<meta name='description' content={description} />
			<meta name='keywords' content={keywords} />
		</Helmet>
	);
};

Meta.defaultProps = {
	title: 'Agrolinka',
	keywords: 'Africas number one agricultural online marketplace',
	description: 'Buy the best agricultural products at the lowest prices',
};
export default Meta;
